const websitePages = [
  '/',
  '/athlete-zone',
  '/fan-zone',
  '/our-athletes',
  '/partners-and-sponsors',
  '/our-story',
  '/event',
  '/rerouter',
  '/news',
  '/stop-the-hate',
  '/terms-and-conditions',
  '/privacy-policy',
  '/child-safety-standard-policy',
  '/community-guidelines'
];

function isWebsite(location) {
  if (websitePages.includes(location)) return true;
  if (location.includes('/articles/')) return true;

  return false;
}

export default isWebsite;
